var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevelDfkltyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_46977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73313 12.2488H7.37501V9.12379H8.62501V12.2488H9.26688C9.34938 11.4975 9.73251 10.8775 10.3544 10.2007C10.425 10.1244 10.8744 9.65879 10.9275 9.59254C11.3689 9.04106 11.6456 8.37612 11.7257 7.67428C11.8058 6.97244 11.686 6.26225 11.3802 5.62551C11.0743 4.98876 10.5948 4.45134 9.99695 4.07515C9.39906 3.69896 8.70707 3.4993 8.00068 3.49915C7.29429 3.499 6.60222 3.69837 6.00417 4.0743C5.40612 4.45024 4.92641 4.98745 4.62029 5.62406C4.31417 6.26068 4.19409 6.97081 4.27388 7.67269C4.35366 8.37456 4.63006 9.03962 5.07126 9.59129C5.12501 9.65817 5.57563 10.1244 5.64501 10.2C6.26751 10.8775 6.65063 11.4975 6.73313 12.2488ZM6.75001 13.4988V14.1238H9.25001V13.4988H6.75001ZM4.09626 10.3738C3.50762 9.63835 3.13872 8.75159 3.03205 7.81565C2.92537 6.87971 3.08526 5.93267 3.49329 5.08363C3.90132 4.23459 4.5409 3.51809 5.33835 3.01666C6.1358 2.51523 7.05868 2.24927 8.00068 2.24942C8.94268 2.24957 9.86547 2.51583 10.6628 3.01751C11.4601 3.5192 12.0994 4.23591 12.5072 5.08508C12.9149 5.93425 13.0745 6.88134 12.9675 7.81724C12.8606 8.75314 12.4914 9.63979 11.9025 10.375C11.515 10.8575 10.5 11.6238 10.5 12.5613V14.1238C10.5 14.4553 10.3683 14.7733 10.1339 15.0077C9.89947 15.2421 9.58153 15.3738 9.25001 15.3738H6.75001C6.41848 15.3738 6.10054 15.2421 5.86612 15.0077C5.6317 14.7733 5.50001 14.4553 5.50001 14.1238V12.5613C5.50001 11.6238 4.48438 10.8575 4.09626 10.3738Z",
    fill: "url(#paint0_linear_443_46977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_46977",
    x1: 7.99988,
    y1: 15.3738,
    x2: 7.99988,
    y2: 2.24942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_46977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.998779)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelDfkltyIcon);
export default __webpack_public_path__ + "static/media/levelDfkltyIcon.ebacd3bf5d923f17d4629b96b7df8fad.svg";
export { ForwardRef as ReactComponent };